import { useGetMetaIntegration } from '../api';
import { MetaAdsWizardModal } from './meta-ads-wizard-modal';

interface MetaConnectSelectionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Fires once the chosen Page and ad account are saved. */
  onSuccess?: () => void;
}

/**
 * The step after the Facebook popup: pick the ad account and Page this
 * workspace should use. With `rollout-meta-connect-selection-dialog` off it
 * shows nothing and connects everything the login reaches; with it on, it
 * connects without asking only when there is one of each.
 *
 * Connecting only stores what the Facebook login can reach; nothing is
 * attached to the workspace until the owner chooses here. Renders nothing
 * until the integration is waiting for that choice, so callers can open it
 * straight from the popup's success callback while the integration refetches.
 */
export function MetaConnectSelectionDialog({
  open,
  onOpenChange,
  onSuccess,
}: MetaConnectSelectionDialogProps) {
  const {
    integration,
    isPendingConfiguration,
    availableAdAccounts,
    availablePages,
  } = useGetMetaIntegration();

  if (!integration || !isPendingConfiguration) return null;

  return (
    <MetaAdsWizardModal
      open={open}
      onOpenChange={onOpenChange}
      integrationId={integration.id}
      availableAdAccounts={availableAdAccounts}
      availablePages={availablePages}
      facebookUserName={integration.facebookUserName}
      onSuccess={onSuccess}
    />
  );
}
